const hotel = {
  availableMealPlans: "Piani pasti disponibili", // translated
  availableRoomsTypes: "Tipi di camere disponibili", // translated
  cancellationPolicy: "Politica di cancellazione", // translated
  freeCancellationAvailable: "Cancellazione gratuita disponibile", // translated
  nonRefundable: "Non rimborsabile", // translated
  priceFor: "prezzo per", // translated
  nights: "notti", // translated
  totalPrice: "Prezzo totale", // translated
  seeAvailability: "Vedi Disponibilità", // translated
  myProfile: "Il mio profilo", // translated
  travelTrust: "Fiducia di viaggio", // translated
  signIn: "Registrazione", // translated
  searchNow: "Cerca ora", // translated
  policy: "Politica", // translated
  cxlPolicy: "Politica CXL", // translated
  beddingType: "Tipo di biancheria da letto", // translated
  maxPax: "Max Pace", // translated
  hotelName: "Nome dell'hotel", // translated
  reservationDate: "Data di prenotazione", // translated
  cancellationRules: "Regole di cancellazione", // translated
  cxlRules: "Regole CXL", // translated
  room: "camera", // translated
};

export default hotel;
